/**
 * ACF 6.0 block - js entrypoint
 *
 * entry point for webpack, can import js scripts and create css files for block
 * @package hum-fse-6-blocks
 */

import "./scss/_animate.scss";
import anime from 'animejs/lib/anime.es.js';

document.addEventListener( 'DOMContentLoaded', function () {

  const animateBlocks = document.querySelectorAll( '.is-intro-animation .acf-innerblocks-container > *' );

  anime({
    targets: animateBlocks,
    translateY: [100, 0],
    delay: 1200,
    duration: 600,
    easing: "cubicBezier(.73,0,.34,.99)",
  });


});